export const mainColors = {
    /**
     * @deprecated - txtDark48 is deprecated - temporarily only used for login
     */
    txtDark48: 'rgba(17, 17, 17, 0.48)',

    main: {
        primary: '#111827',
        secondary: '#3b82f6',
    },

    default: {
        dark: '#000000',
        light: '#ffffff',
        transparent: 'transparent',
    },

    text: {
        light: '#ffffff',
        dark: '#000000',
        secondary: '#3b82f6',
    },

    grays: {
        gray100: '#f8fafc',
        gray200: '#edf3f9',
        gray300: '#c4d1e1',
        gray400: '#64748b',
        gray500: '#1e293b',
    },

    extendedSecondary: {
        secondary100: '#eef5ff',
        secondary200: '#bed5fc',
        secondary300: '#7cacf9',
        secondary400: '#2757a4',
    },

    status: {
        info: '#3b82f6',
        details: '#edf4ff',
        success: '#10b981',
        active: '#f1fffa',
        warning: '#f59e0b',
        scheduled: '#fffbf3',
        error: '#ef4444',
        ended: '#fff6f6',
    },
};

/* Navigation Colors */
export const navigation = {
    bgColor: mainColors.grays.gray100,
    bgColorTab: mainColors.default.light,
    bgColorTabActive: mainColors.main.secondary,
    txtColor: mainColors.main.primary,
    txtColorActive: mainColors.default.light,
    txtColorCounter: mainColors.default.light,
    txtColorCounterActive: mainColors.main.secondary,
};

/* Casino & Live Casino Colors  */
/* TODO: change colors names when working on new designs for casino cms */
export const casinoColors = {
    txtColor: mainColors.main.primary,
    txtColorInfo: mainColors.grays.gray400,
    txtColorCategoryHeader: mainColors.default.light,
    txtColorGameName: mainColors.default.dark,
    txtColorStatusActive: mainColors.status.success,
    txtColorStatusInactive: mainColors.status.error,

    bgColorCategoryHeader: mainColors.grays.gray400,
    bgColorCategoryHeaderControls: mainColors.main.secondary,
    bgColorGameRow: mainColors.default.light,
    bgColorPage: mainColors.grays.gray100,
    bgColorInput: mainColors.grays.gray100,

    iconColorCheckbox: mainColors.default.light,
    iconColorGame: mainColors.grays.gray400,
    iconColorCategory: mainColors.default.light,

    // COLORS FOR OLD DESIGNS --> TODO: remove after change it to new
    buttonColorRemoveImg: mainColors.status.error,
    buttonColorOptimiseImg: mainColors.status.success,
    txtColorWarningInfo: mainColors.status.error,

    paleGrey: mainColors.grays.gray200,
    coolBlue: mainColors.main.secondary,
    lighterBlue: '#71A9F7',
    blueGray: mainColors.grays.gray300,
    lightPeriwinkle: mainColors.grays.gray200,
    white: mainColors.default.light,
    disabledGray: mainColors.grays.gray300,
    veryLightPink: mainColors.grays.gray400,
    black: mainColors.default.dark,
    // --> END COLORS FOR OLD DESIGNS
};

/* Landing Page Colors */
export const lpPageColors = {
    paleGrey: '#edf2fa',
    indicatorBlue: '#71A9F7',
    activeLabel: mainColors.grays.gray400,
    assetsText: '#060c18',
    copiedMessage: mainColors.status.success,
    homepageIndicatorBg: mainColors.status.error,
    homepageWarningColor: '#ffc107',
    homepageErrorColor: mainColors.status.error,
    uploadImgButtonBg: mainColors.main.secondary,
    moveOrderColor: mainColors.main.secondary,
    disabledMoveOrderColor: mainColors.grays.gray300,
};

/* transactionHistoryTabColors */
export const transactionHistoryTabColors = {
    txtColor: mainColors.default.dark,
    txtColorSecondary: mainColors.status.error,
};

/* Compliance And Audit Tab Colors */
export const complianceAuditTabColors = {
    headerTitle: '#2b2b2b',
    resultReportBg: '#fafafa',
    linkColor: '#05a6ef',
    infoTxtColor: '#000',
};

/* Automatic Withdrawals Colors */
export const automaticWithdrawalColors = {
    buttonFilterColor: '#71a9f7',
};

/* FraudAndCompliance Colors */
export const fraudAndComplianceColors = {
    commonTable: {
        txtColor: mainColors.main.primary,
        txtColorMessage: '#31708f',
        bgColor: mainColors.default.light,
        bgColorMessage: '#d9edf7',
        bgColorRowYourFirst: '#dcfaed',
        bgColorRowYourSecond: '#f8fefb',
        bgColorRowPendingFirst: '#fbdfda',
        bgColorRowPendingSecond: '#fcedea',
        bgColorRowOtherFirst: '#f6f9fc',
        bgColorRowOtherSecond: mainColors.default.light,
        borderColorDefault: mainColors.grays.gray200,
        borderColorWhite: mainColors.default.light,
        borderColorYour: '#dcfaed',
        borderColorPending: '#fbdfda',
        borderColorOther: '#f6f9fc',
        iconColorChevron: mainColors.main.primary,
        bgColorSelect: mainColors.grays.gray200,
    },

    withdrawalReqColors: {
        txtColor: mainColors.main.primary,
        txtColorCustomerId: mainColors.grays.gray400,
        bgColor: mainColors.default.light,
        bgColorButton: mainColors.main.secondary,
    },
    matchedAccount: {
        bgColorCustomerTab: mainColors.default.light,
    },
    depositRestrictions: {
        bgColorCustomerTab: mainColors.default.light,
    },
};

/* Affordability Excluded Colors */
export const affordabilityExcludedColors = {
    mainColor: '#444',
    mainColorSecondary: '#f4f4f4',
    mainColorTertiary: '#EDF2FA',
    mainColorQuaternary: '#eee',
    borderBottomColorSelected: '#3d76ca',
    liColor: '#aaa',
    oddTableColor: '#F6F9FC',
    evenTableColor: '#FFF',

    txtColor: '#D7263D',
    txtColorSecondary: '#FDC500',
    txtColorTertiary: '#45CB85',
    txtColorQuaternary: '#000',
    bgColor: 'rgb(215, 38, 61, .16)',
    bgColorSecondary: 'rgb(253, 197, 0, .16)',
    bgColorTertiary: 'rgb(69, 203, 133, .16)',
    bgColorQuaternary: 'rgb(0, 0, 0, 0)',
};

export const pepAndSanctionsColors = {
    mainColor: '#444',
    borderBottomColorSelected: '#3d76ca',
    liColor: '#aaa',
    oddTableColor: '#F6F9FC',
    evenTableColor: '#FFF',
    txtColor: '#000',
};

export const telebetColors = {
    //row template
    txtColor: '#111111',
    txtColorMeta: 'rgba(2, 13, 22, 0.4)',
    bgColorSelectionHover: mainColors.status.warning,
    buttonBackground: mainColors.main.secondary,
    matchBet: {
        bgColorMarketTitle: '#e8ebef',
    },
};

export const srgQuestions = {
    borderColor: mainColors.grays.gray200,
    checkIconColor: mainColors.status.success,
    wrongIconColor: mainColors.status.error,
};

/* New color configs - please use values only from mainColors */

export const layout = {
    bgColor: mainColors.grays.gray200,
};

export const nav = {
    cms: {
        bgColor: mainColors.grays.gray500,
        bgColorSecondary: mainColors.default.transparent,
        txtColor: mainColors.default.light,
        txtColorSecondary: mainColors.text.secondary,
    },
};

export const form = {
    bgColor: mainColors.default.light,
    bgColorSecondary: mainColors.grays.gray100,
};

export const button = {
    primary: {
        bgColor: mainColors.main.secondary,
        borderColor: mainColors.main.secondary,
        txtColor: mainColors.default.light,

        ok: {
            bgColor: mainColors.status.success,
            borderColor: mainColors.status.success,
        },

        error: {
            bgColor: mainColors.status.error,
            borderColor: mainColors.status.error,
        },
    },
    secondary: {
        bgColor: mainColors.default.transparent,
        borderColor: mainColors.main.secondary,
        txtColor: mainColors.main.secondary,

        ok: {
            borderColor: mainColors.status.success,
            txtColor: mainColors.status.success,
        },

        error: {
            borderColor: mainColors.status.error,
            txtColor: mainColors.status.error,
        },
    },
};

export const formLabel = {
    txtColor: mainColors.grays.gray400,
    txtColorSecondary: mainColors.grays.gray500,
    txtColorTertiary: mainColors.status.error,
};

export const input = {
    bgColor: mainColors.default.light,
    borderColor: mainColors.grays.gray300,
    borderColorSecondary: mainColors.grays.gray400,
    borderColorTertiary: mainColors.status.error,
    txtColor: mainColors.grays.gray500,
    txtColorSecondary: mainColors.grays.gray300,

    readOnly: {
        bgColor: mainColors.grays.gray200,
        borderColor: '',
        txtColor: '',
    },
};

export const select = {
    bgColor: mainColors.default.light,
    bgColorSecondary: mainColors.grays.gray500,
    bgColorTertiary: mainColors.default.transparent,

    txtColor: mainColors.grays.gray500,
    txtColorSecondary: mainColors.grays.gray300,

    borderColor: mainColors.grays.gray300,
    borderColorSecondary: mainColors.grays.gray400,
    borderColorTertiary: mainColors.main.secondary,

    option: {
        bgColor: mainColors.grays.gray100,
        bgColorSecondary: mainColors.extendedSecondary.secondary200,
        bgColorTertiary: mainColors.extendedSecondary.secondary100,
    },

    chevron: {
        bgColor: mainColors.grays.gray300,
        bgColorSecondary: mainColors.grays.gray400,
    },

    /**
     * @deprecated - to be deleted after changing to new select
     */
    primary: {
        bgColor: mainColors.grays.gray200,
        borderColor: mainColors.grays.gray400,
        txtColor: mainColors.default.dark,
    },

    /**
     * @deprecated - to be deleted after changing to new select
     */
    secondary: {
        bgColor: mainColors.default.light,
        borderColor: mainColors.main.secondary,
        txtColor: mainColors.main.secondary,
    },
};

export const list = {
    bgColor: mainColors.default.light,

    listItem: {
        bgColor: mainColors.default.light,
        bgColorSecondary: mainColors.grays.gray100,
        borderColor: mainColors.grays.gray200,
        borderColorSecondary: mainColors.grays.gray300,

        txtColor: mainColors.grays.gray500,

        subsectionOne: {
            bgColor: mainColors.extendedSecondary.secondary100,
            borderColor: mainColors.grays.gray300,
        },

        subsectionTwo: {
            bgColor: mainColors.extendedSecondary.secondary200,
            borderColor: mainColors.extendedSecondary.secondary100,
        },

        image: {
            bgColor: mainColors.grays.gray200,
        },

        icon: {
            bgColor: mainColors.grays.gray300,
            bgColorSecondary: mainColors.grays.gray400,
            bgColorTertiary: mainColors.grays.gray500,
        },
    },
};

export const toggle = {
    txtColor: mainColors.grays.gray400,
    bgColor: mainColors.main.secondary,
    bgColorSecondary: mainColors.grays.gray300,
    bgColorTertiary: mainColors.default.light,
};

export const moreActions = {
    bgColor: mainColors.grays.gray100,
    bgColorSecondary: mainColors.extendedSecondary.secondary100,
    bgColorTertiary: mainColors.grays.gray300,
    bgColorQuaternary: mainColors.grays.gray400,
    bgColorQuinary: mainColors.grays.gray500,
    txtColor: mainColors.grays.gray500,
};

export const tooltip = {
    bgColor: mainColors.default.light,
    txtColor: mainColors.grays.gray400,
    borderColor: mainColors.main.secondary,
};

export const tabs = {
    slider: {
        bgColor: mainColors.main.secondary,
        borderColor: mainColors.extendedSecondary.secondary200,
        txtColor: mainColors.main.secondary,
        txtColorSecondary: mainColors.text.dark,
    },
    box: {
        bgColor: mainColors.extendedSecondary.secondary100,
        borderColor: mainColors.grays.gray300,
        txtColor: mainColors.text.secondary,
        txtColorSecondary: mainColors.grays.gray300,
    },
};

export const statusLabel = {
    live: {
        bgColor: mainColors.status.active,
        txtColor: mainColors.status.success,
    },
    scheduled: {
        bgColor: mainColors.status.scheduled,
        txtColor: mainColors.status.warning,
    },
    ended: {
        bgColor: mainColors.status.ended,
        txtColor: mainColors.status.error,
    },
    info: {
        bgColor: mainColors.status.details,
        txtColor: mainColors.status.info,
    },
};

export const customerBadges = {
    darkGreen: '#008800',
    mediunGreen: '#66bb6a',
    lightGreen: '#c8e6c9',
    lightRed: '#ffcdd2',
    mediumRed: '#e57373',
    darkRed: '#FF0000',
    grey: '#f2f2f2',
};

export const badgeColors = {
    amber: { bgColor: '#ff8000', txtColor: '#ffffff' },
    gray: { bgColor: '#f2f2f2', txtColor: '#010000' },
    'dark-green': { bgColor: '#008800', txtColor: '#ffffff' },
    'medium-green': { bgColor: '#66bb6a', txtColor: '#ffffff' },
    'light-green': { bgColor: '#c8e6c9', txtColor: '#010000' },
    'light-red': { bgColor: '#ffcdd2', txtColor: '#010000' },
    'medium-red': { bgColor: '#e57373', txtColor: '#ffffff' },
    'dark-red': { bgColor: '#ff0000', txtColor: '#ffffff' },
};

export type BadgeType = keyof typeof badgeColors;

// TODO - use configs below

export const checkbox = {
    label: mainColors.grays.gray300,
};

export const scrollbar = {
    bgColor: mainColors.grays.gray300,
    bgColorSecondary: mainColors.default.transparent,
};

export const dropdown = {
    label: '#666',
};

// TODO - add configs

// export const uploader = { image: {}, csv: {}, library: {} };

// export const loginPage = {};

// export const errorMessages = {}

export const auditIdMissionColors = {
    wrapper: {
        bgColor: mainColors.default.light,
    },
    table: {
        evenRowBgColor: mainColors.grays.gray200,
        borderColor: mainColors.grays.gray300,
        headerBgColor: mainColors.grays.gray100,
    },
    jsonDetails: {
        rowBgColor: mainColors.grays.gray100,
        titleColor: mainColors.main.primary,
        contentBgColor: mainColors.grays.gray200,
    },
};

export const dropdownWrapper = {
    control: {
        bgColor: mainColors.default.light,
        borderColor: mainColors.grays.gray300,
        borderColorLight: mainColors.grays.gray200,
        txtColor: mainColors.grays.gray500,
    },
    placeholder: {
        txtColor: mainColors.grays.gray400,
    },
    indicator: {
        bgColor: mainColors.grays.gray400,
    },
    menu: {
        bgColor: mainColors.default.light,
        borderColor: mainColors.grays.gray300,
        shadowColor: 'rgba(0, 0, 0, 0.06)',
    },
    option: {
        bgColor: mainColors.default.light,
        bgColorHover: mainColors.grays.gray100,
        bgColorSelected: mainColors.extendedSecondary.secondary100,
        bgColorFocused: mainColors.extendedSecondary.secondary100,
        txtColor: mainColors.grays.gray400,
        txtColorSelected: mainColors.grays.gray500,
        borderColor: mainColors.grays.gray300,
    },
    scrollbar: {
        thumbColor: 'rgba(0, 0, 0, 0.15)',
        trackColor: mainColors.default.transparent,
    },
    noOptions: {
        txtColor: mainColors.grays.gray400,
    },
    deleteButton: {
        bgColor: mainColors.default.transparent,
        bgColorHover: mainColors.status.error,
        borderColor: mainColors.grays.gray300,
        txtColor: mainColors.default.light,
    },
};

export const addButton = {
    bgColor: mainColors.grays.gray300,
    bgColorIcon: '#99cc00',
    txtColor: mainColors.default.light,
};

export const licenseConfig = {
    bgColor: mainColors.default.light,
    txtColor: mainColors.main.primary,
    txtColorSecondary: mainColors.grays.gray400,

    borderColor: mainColors.grays.gray300,
    borderColorSecondary: mainColors.grays.gray200,

    focusColor: mainColors.main.secondary,

    error: {
        bgColor: mainColors.status.error,
        txtColor: mainColors.default.light,
    },
};

export const inputField = {
    borderColor: mainColors.grays.gray300,
    borderColorModified: mainColors.status.success,
    borderColorError: mainColors.status.error,
    borderColorFocus: mainColors.main.secondary,

    bgColor: mainColors.default.light,
    bgColorError: mainColors.status.ended,
    bgColorDisabled: mainColors.grays.gray200,

    txtColor: mainColors.grays.gray500,

    tooltip: {
        bgColor: mainColors.main.primary,
        txtColor: mainColors.default.light,
    },
};

export const TableColor = {
    bgPrimary: '#f6f9fc',
};
